<template>
    <div>
        <!-- Skeleton while loading -->
        <div v-if="loading">
            <div class="tw:flex tw:justify-center">
                <div class="skeleton-card tw:w-full tw:max-w-[430px] tw:h-[270px] tw:bg-gray-200 tw:rounded-xl tw:shadow-sm"></div>
            </div>

            <div class="tw:flex tw:justify-center tw:mt-4">
                <div class="tw:h-9 tw:w-44 tw:bg-gray-200 tw:rounded"></div>
            </div>
        </div>

        <!-- Card info when loaded -->
        <div v-else-if="tarjeta">
            <div class="tw:flex tw:justify-center">
                <VuePaycard
                    :value-fields="cardFields"
                    :labels="cardLabels"
                />
            </div>
            <div class="tw:flex tw:justify-center tw:mt-4">
                <Button
                    @click="$emit('editar')"
                >
                    Editar información de pago
                </Button>
            </div>
        </div>

        <!-- Error state -->
        <div v-else-if="error" class="tw:px-6 tw:text-center tw:py-8">
            <p class="tw:text-sm tw:text-red-500 tw:mb-4">
                {{ error }}
            </p>
            <Button
                @click="$emit('editar')"
            >
                Editar informaci&oacute;n de pago
            </Button>
        </div>

        <!-- Empty state: no card registered -->
        <div v-else class="tw:px-6 tw:text-center tw:py-8">
            <p class="tw:text-sm tw:text-gray-500 tw:mb-4">
                No hay informaci&oacute;n de pago asociada a este usuario.
            </p>
            <Button
                @click="$emit('editar')"
            >
                A&ntilde;adir tarjeta
            </Button>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { VuePaycard } from 'vue-paycard';
    import Button from '@/modules/admin/ui/Button.vue';
    import { useInformacionPago } from '@/composables/admin/usuarios/useInformacionPago';

    const props = defineProps({
        listaId: { type: [String, Number], required: true },
        userId: { type: [String, Number], required: true },
        tid: { type: String, required: true },
    });

    defineEmits(['editar']);

    const { loading, tarjeta, error } = useInformacionPago(
        props.listaId,
        props.userId,
        props.tid,
    );

    const cardFields = computed(() => ({
        cardName: tarjeta.value?.titular ?? '',
        cardNumber: tarjeta.value?.panVuePayCard ?? '',
        cardMonth: tarjeta.value?.mesCaducidad ?? '',
        cardYear: tarjeta.value?.anoCaducidad ?? '',
        cardCvv: '',
    }));

    const cardLabels = {
        cardHolder: 'Titular',
        cardMonth: 'MM',
        cardYear: 'YY',
        cardExpires: 'Caducidad',
        cardCvv: 'CVV',
    };
</script>

<style scoped>
    ::v-deep .card-item__side {
        box-shadow: 0 4px 24px 0 rgba(14, 42, 90, 0.35);
    }

    @media (max-width: 480px) {
        ::v-deep .card-item {
            width: 100% !important;
            height: 240px !important;
        }

        .skeleton-card {
            max-width: 370px !important;
            height: 240px !important;
        }

        ::v-deep .card-item__date {
            width: auto;
            min-width: 96px;
            padding: 6px 12px;
        }

        ::v-deep .card-item__dateTitle {
            font-size: 11px;
            padding-bottom: 3px;
        }
    }
</style>
